var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTm = function SvgTm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#616c812b-5dc0-41ac-95d8-d9a1942195f8a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e7f3bec6-4b4c-45d0-87cb-c21061e12f97b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e7f3bec6-4b4c-45d0-87cb-c21061e12f97b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2DB771",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4B339",
    fillRule: "evenodd",
    d: "M2 0h1v15H2zm2 0h1v15H4zm2 0h1v15H6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE6A3E",
    fillRule: "evenodd",
    d: "m5 0 2 1.5L5 3zm0 3 2 1.5L5 6zm0 3 2 1.5L5 9zm0 3 2 1.5L5 12zm0 3 2 1.5L5 15zM4 0 2 1.5 4 3zm0 3L2 4.5 4 6zm0 3L2 7.5 4 9zm0 3-2 1.5L4 12zm0 3-2 1.5L4 15zM4 0h1v2H4zm0 13h1v2H4zm0-8h1v2H4zm0-2h1v1H4zm0 8h1v1H4zm0-3h1v2H4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.236 3.014A2.5 2.5 0 1 1 11.5 8a2.5 2.5 0 0 1-2.486-2.764 2 2 0 1 0 2.222-2.222M10 4h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EE2C0",
    fillRule: "evenodd",
    d: "M8 4h1v1H8zm2-2h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "616c812b-5dc0-41ac-95d8-d9a1942195f8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgTm;